import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutReprintFreightBill extends Layout {
    sourceReprintFreightBills: DataSource;
}
